import React from "react";
import { connect } from "react-redux";
import moment from "moment";
import {Button,Icon,Input,Modal,Form,Row,Col,Radio,DatePicker,InputNumber,Spin,TreeSelect,Select} from 'antd';

import "./style.css";
import LayoutWrapper from '../../layouts/LayoutWrapper';
import ReduxComponent from '../ReduxComponent';
import {
	changeRecruitmentRequirement,
	selectRecruitmentRequirement,
	updateRecruitmentRequirement,
} from "../../actions/recruitment-actions";
import recruitmentRequirementService from "../../services/Recruitment/recruitment-requirement-service";
import { fetchEmployeesList } from '../../actions/employee-management-actions.js';
const webConfig = require ('../../config.json');


class RecruitmentRequirement extends ReduxComponent {

	initReload = true;
	moduleName = "recruitment";
	childModuleName = "recruitmentRequirement";

	state = {
		currentModalStatus: false,
		currentIndex: false,
		currentData: {},
		currentDataStatus: "unload"
	}

	actions = {
		changeAction: this.props.changeRecruitmentRequirement,
		selectAction: this.props.selectRecruitmentRequirement,
		updateAction: this.props.updateRecruitmentRequirement,
		deleteAction: recruitmentRequirementService.deleteRecruitmentRequirement,
		createAction: recruitmentRequirementService.createRecruitmentRequirement,
	}

	setKeywordFilter = value => this.actions.changeAction({position_name: value}, "reload")

	changeKeywordFilter = event => {
		if (!event.target.value) {
			this.actions.changeAction({position_name: ""}, "reload")
		}
	}

	createData = () => this.setState({
		currentModalStatus: true,
		currentIndex: null,
		currentDataStatus: "unload"
	}, () => recruitmentRequirementService.initiaRecruitmentRequirement({}, res => {
		console.log(res);
		if (res.data.Success) {
			this.setState({
				currentDataStatus: "loaded",
				...res.data.Object,
				currentData: {
					department_id: "",
					gender: 0,
					status: 1,
					employee_type: 2
				},
			})
		}else{
			this.setState({currentDataStatus: "error"})
		}
	}, err => this.setState({currentDataStatus: "error"})))

	updateData = (record, index) => this.setState({
		currentModalStatus: true,
		currentIndex: index,
		currentDataStatus: "unload",
		currentData: record
	}, () => recruitmentRequirementService.iniputRecruitmentRequirement({id: record.id}, res => {
		console.log(res);
		if (res.data.Success) {
			this.setState({
				currentDataStatus: "loaded",
				...res.data.Object,
			})
		}else{
			this.setState({currentDataStatus: "error"})
		}
	}, err => this.setState({currentDataStatus: "error"})))

	column = [{
			title: '职位',
			dataIndex: 'position_name',
			key: 'position_name',
			className: 'table-global-head-short'
		},{
			title: '部门',
			dataIndex: 'department_name',
			key: 'department_name',
			className: 'table-global-head'
		}, {
			title: '计划招聘人数',
			dataIndex: 'employee_count',
			key: 'employee_count',
			className: 'table-global-head-short'
		}, {
			title: '实际招聘人数',
			dataIndex: 'actual_employee_count',
			key: 'actual_employee_count',
			className: 'table-global-head-short'
		}, {
			title: '员工类型',
			dataIndex: 'employee_type_name',
			key: 'employee_type_name',
			className: 'table-global-head-small'
		}, {
			title: '招聘执行人',
			dataIndex: 'hr_name',
			key: 'hr_name',
			className: 'table-global-head-small'
		}, {
			title: '招聘申请时间',
			dataIndex: 'created_time_str',
			key: 'created_time_str',
			className: 'table-global-head-small'
		}, {
			title: '拟到岗时间',
			dataIndex: 'to_post_time_str',
			key: 'to_post_time_str',
			className: 'table-global-head-small'
		}, {
			title: '招聘申请状态',
			dataIndex: 'status_name',
			key: 'status_name',
			className: 'table-global-head-short'
		}, {
			title: '操作',
			dataIndex: 'actions',
			key: 'actions',
			className: 'table-global-head-small',
			render: (text, record, index) => {
				return this.props.access.recruitmentRequirement.u_value &&
					<span>
						<Button icon="edit" size="small"
							className="row-action-btn"
							onClick={this.updateData.bind(this, record, index)}>编辑</Button>
					</span>
				
			} 
		}
	]

	renderTreeNodes = data => data.map(item => {
		if (item.children) {
			return (
				<TreeSelect.TreeNode title={item.name}
					value={item.id + ""}
					key={item.id}
					dataRef={item}>
						{ item.children.length !== 0 && this.renderTreeNodes(item.children) }
				</TreeSelect.TreeNode>
			);
		}
		return <TreeSelect.TreeNode {...item} />
	})

	selectEmployee = value => this.props.fetchEmployeesList({real_name: value})

	setRecruitmentHr = (value, event) => this.setState({
		currentData: {
			...this.state.currentData,
			hr_id: event.props.employee_id
		}
	})

	publicSubmit = () => {
		this.props.form.validateFields((err, values) => {
			if (!err) {
				let currentData = {
					...this.state.currentData,
					...values,
					to_post_time: values.to_post_time.format("YYYY-MM-DD")
				}
				console.log(currentData);
				let callee = null === this.state.currentIndex ? this.publicCreate : this.publicUpdate;
				callee(currentData);
			}
		})
	}

	render() {
		return (
			<div className="app-module-item">
				<Modal width="1000px"
					visible={this.state.currentModalStatus}
					title="招聘需求"
					destroyOnClose={true}
					onCancel={this.toggleCurrentModal.bind(this, false)}
					onOk={this.publicSubmit} >
					<div className="app-modal-item">
					{(() => {
						switch (this.state.currentDataStatus) {
							case "reload":
							case "loaded":
								return (
									<Form onSubmit={this.publicSubmit} layout="inline">
										<Row style={{marginBottom: "10px"}}>
											<Col span={12}>
												<div style={{marginBottom:"15px"}}>
													<Form.Item label="招聘岗位">
														{this.props.form.getFieldDecorator('position_name', {
															rules: [{ required: true, message: '请输入招聘岗位' }],
															initialValue: this.state.currentData.position_name
														})(<Input style={{width:"240px"}} />)}
													</Form.Item>
												</div>
											</Col>
											<Col span={12}>
												<div style={{marginBottom:"15px"}}>
													<Form.Item label="部门">
														{this.props.form.getFieldDecorator('department_id', {
															rules: [{ required: true, message: '请选择部门' }],
															initialValue: this.state.currentData.department_id + ""
														})(<TreeSelect style={{width:"240px"}}
																placeholder="请选择部门"
																showSearch={false}
																autoExpandParent={true}
																dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
																treeDefaultExpandAll >
																{this.renderTreeNodes(this.state.departments)}
															</TreeSelect>
														)}
													</Form.Item>
												</div>
											</Col>
											<Col span={12}>
												<div style={{marginBottom:"15px"}}>
													<Form.Item label="招聘人数">
														{this.props.form.getFieldDecorator('employee_count', {
															rules: [{ required: true, message: '请输入招聘人数' }],
															initialValue: this.state.currentData.employee_count
														})(<InputNumber style={{width:"240px"}} />)}
													</Form.Item>
												</div>
											</Col>
											<Col span={12}>
												<div style={{marginBottom:"15px"}}>
													<Form.Item label="工作地点">
														{this.props.form.getFieldDecorator('work_place', {
															rules: [{ required: true, message: '请输入工作地点' }],
															initialValue: this.state.currentData.work_place
														})(<Input style={{width:"240px"}} />)}
													</Form.Item>
												</div>
											</Col>
											<Col span={12}>
												<div style={{marginBottom:"15px"}}>
													<Form.Item label="实际招聘人数">
														{this.props.form.getFieldDecorator('actual_employee_count', {
															rules: [{ required: true, message: '请输入实际招聘人数' }],
															initialValue: this.state.currentData.actual_employee_count
														})(<InputNumber style={{width:"240px"}} />)}
													</Form.Item>
												</div>
											</Col>
											<Col span={12}>
												<div style={{marginBottom:"15px"}}>
													<Form.Item label="招聘执行人">
														{this.props.form.getFieldDecorator('hr_name', {
															rules: [{ required: true, message: '请输入招聘执行人' }],
															initialValue: this.state.currentData.hr_name
														})(
															<Select mode="combobox"
																style={{ width: "240px" }}
																onSearch={this.selectEmployee}
																filterOption={false}
																placeholder="请输入员工姓名"
																onSelect={this.setRecruitmentHr} >
																{this.props.employeeManagement.employeeList && this.props.employeeManagement.employeeList.Data instanceof Array &&
																	this.props.employeeManagement.employeeList.Data.map(employee => {
																	return (
																		<Select.Option key={employee.id} 
																			value={employee.real_name}
																			employee_id={employee.id}
																			style={{width:"240px"}}>
																			{employee.real_name}
																		</Select.Option>
																	)
																})}
															</Select>
														)}
													</Form.Item>
												</div>
											</Col>
											<Col span={12}>
												<div style={{marginBottom:"15px"}}>
													<Form.Item label="到岗时间">
														{this.props.form.getFieldDecorator('to_post_time', {
															rules: [{ required: true, message: '请输入到岗时间' }],
															initialValue: this.state.currentData.to_post_time ?
																moment(this.state.currentData.to_post_time) : null
														})(<DatePicker style={{width:"240px"}} />)}
													</Form.Item>
												</div>
											</Col>
											<Col span={12}>
												<div style={{marginBottom:"15px"}}>
													<Form.Item label="员工类型">
														{this.props.form.getFieldDecorator('employee_type', {
															rules: [{ required: true, message: '请选择员工类型' }],
															initialValue: this.state.currentData.employee_type
														})(
															<Radio.Group style={{width:"240px",textAlign:"left"}}>
																<Radio.Button value={1}>短期</Radio.Button>
																<Radio.Button value={2}>长期</Radio.Button>
															</Radio.Group>
														)}
													</Form.Item>
												</div>
											</Col>
                      <Col span={24}>
                        <div style={{marginBottom:"15px"}}>
                        <Form.Item label="申请原因">
                            {this.props.form.getFieldDecorator('reason', {
                              rules: [{ required: true, message: '请输入申请原因' }],
                              initialValue: this.state.currentData.reason
                            })(<Input.TextArea rows={5} style={{width:"710px"}} />)}
                        </Form.Item>
                      </div>
                      </Col>
										</Row>
										<div style={{textAlign:"left"}}>岗位要求</div>
										<hr />
										<Row style={{marginBottom: "10px"}}>
											<Col span={12}>
												<div style={{marginBottom:"15px"}}>
													<Form.Item label="性别">
														{this.props.form.getFieldDecorator('gender', {
															rules: [{ required: true, message: '请选择性别' }],
															initialValue: this.state.currentData.gender
														})(
															<Radio.Group style={{width:"240px",textAlign:"left"}}>
																<Radio.Button value={0}>不限</Radio.Button>
																<Radio.Button value={1}>男</Radio.Button>
																<Radio.Button value={2}>女</Radio.Button>
															</Radio.Group>
														)}
													</Form.Item>
												</div>
											</Col>
											<Col span={12}>
												<div style={{marginBottom:"15px"}}>
													<Form.Item label="学历">
														{this.props.form.getFieldDecorator('education_background', {
															rules: [{ required: true, message: '请输入学历' }],
															initialValue: this.state.currentData.education_background
														})(<Input style={{width:"240px"}} />)}
													</Form.Item>
												</div>
											</Col>
											<Col span={12}>
												<div style={{marginBottom:"15px"}}>
													<Form.Item label="年龄范围">
														{this.props.form.getFieldDecorator('age_scope', {
															rules: [{ required: true, message: '请输入年龄范围' }],
															initialValue: this.state.currentData.age_scope
														})(<Input style={{width:"240px"}} />)}
													</Form.Item>
												</div>
											</Col>
											<Col span={12}>
												<div style={{marginBottom:"15px"}}>
													<Form.Item label="工作经验">
														{this.props.form.getFieldDecorator('work_experience', {
															rules: [{ required: true, message: '请输入工作经验' }],
															initialValue: this.state.currentData.work_experience
														})(<Input style={{width:"240px"}} />)}
													</Form.Item>
												</div>
											</Col>
											<Col span={12}>
												<div style={{marginBottom:"15px"}}>
													<Form.Item label="专业">
														{this.props.form.getFieldDecorator('major', {
															rules: [{ required: true, message: '请输入专业' }],
															initialValue: this.state.currentData.major
														})(<Input style={{width:"240px"}} />)}
													</Form.Item>
												</div>
											</Col>
											<Col span={12}>
												<div style={{marginBottom:"15px"}}>
													<Form.Item label="薪资范围(元/月)">
														{this.props.form.getFieldDecorator('salary_scope', {
															rules: [{ required: true, message: '请输入薪资范围' }],
															initialValue: this.state.currentData.salary_scope
														})(<Input style={{width:"240px"}} />)}
													</Form.Item>
												</div>
											</Col>
											<Col span={24}>
												<div style={{marginBottom:"15px"}}>
													<Form.Item label="其他要求">
														{this.props.form.getFieldDecorator('another_requirement', {
															rules: [{ required: true, message: '请输入其他要求' }],
															initialValue: this.state.currentData.another_requirement
														})(<Input.TextArea rows={5} style={{width:"710px"}} />)}
													</Form.Item>
												</div>
											</Col>
											<Col span={12}>
												<div style={{marginBottom:"15px"}}>
													<Form.Item label="申请状态">
														{this.props.form.getFieldDecorator('status', {
															rules: [{ required: true, message: '请选择申请状态' }],
															initialValue: this.state.currentData.status
														})(
															<Radio.Group style={{width:"240px",textAlign:"left"}}>
																<Radio.Button value={1}>未开始</Radio.Button>
																<Radio.Button value={2}>进行中</Radio.Button>
																<Radio.Button value={3}>已完成</Radio.Button>
															</Radio.Group>
														)}
													</Form.Item>
												</div>
											</Col>
										</Row>
									</Form>)
							case "error":
								return (
									<div style={{textAlign:'center', margin: '100px 0px'}}>
										{webConfig.httpFetchErrorInformation}
									</div>);
							case "loading":
							case "unload":
								return (
									<div style={{textAlign:'center', margin: '100px 0px'}}>
										<Spin size="large" />
									</div>);
							default :
								return null;
						}
					})()}
					</div>
				</Modal>
				<div style={{marginBottom: "20px"}}>
					{this.props.access.recruitmentRequirement.c_value && <div className="colAction" style={{float:"left", margin:"0px 10px 10px 0px"}}>
						<Button type="primary" onClick={this.createData}>
							<Icon type="plus-circle-o" />
							<span>发起招聘</span>
						</Button>
					</div>}
					{this.props.access.recruitmentRequirement.d_value && <div className="colAction" style={{float:"left", margin:"0px 10px 10px 0px"}}>
						<Button type="primary" onClick={this.publicDelete}>
							<Icon type="delete" />
							<span>批量删除</span>
						</Button>
					</div>}
					<div className="colAction" style={{float:"right", margin:"0px 10px 10px 0px"}}>
						<Input.Search
							placeholder="关键词"
							onSearch={this.setKeywordFilter}
							onChange={this.changeKeywordFilter}
							style={{ width: 200 }}
							defaultValue={this.props[this.moduleName][this.childModuleName].filters.keyword}
							enterButton />
					</div>
					<div style={{clear: "both"}}></div>
				</div>
				<div>{this.publicTableView()}</div>
			</div>
		)
	}
}

const mapStateToProps = state => {
	return {
		recruitment: state.recruitment,
		employeeManagement: state.employeeManagement
	}
}

const mapDispatchToProps = {
	changeRecruitmentRequirement,
	selectRecruitmentRequirement,
	updateRecruitmentRequirement,
	fetchEmployeesList,
}

RecruitmentRequirement = Form.create()(RecruitmentRequirement);

export default LayoutWrapper(connect(mapStateToProps, mapDispatchToProps)(RecruitmentRequirement));




// WEBPACK FOOTER //
// ./src/routes/Recruitment/RecruitmentRequirement.js